export default __webpack_public_path__ + "static/media/Fidelity_and_Computer_Crime_Insurance_Policy_1_March_2023.713a89d1.pdf";